<template>
  <div class="user-wrapper">
    <div class="subpage__inner">
      <SubpageNav :links="links"/>
      <transition name="fade-up">
        <router-view/>
      </transition>
    </div>
  </div>
</template>
<script>
import SubpageNav from '@/components/SubpageNav'
export default {
  name: 'User',
  components: {
    SubpageNav
  },
  data () {
    return {
      links: [
        {
          id: 0,
          title: 'Hesap Ayarları',
          to: { name: 'UserSettings' }
        },
/*         {
          id: 2,
          title: 'Teklifler',
          to: { name: 'UserOffers' }
        }, */
        {
          id: 4,
          title: 'Favorilerim',
          to: { name: 'UserFavorites' }
        },
        {
          id: 3,
          title: 'Yorumlarım',
          to: { name: 'UserComment' }
        },        
      ]
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/components/user";
</style>
